import { toast } from "sonner";

/** Run a settings save, toast the outcome, then reload the settings document. */
export async function saveWithToast(request, successMessage, reload) {
  try {
    const result = await request();
    toast.success(typeof successMessage === "function" ? successMessage(result) : successMessage);
    await reload();
  } catch (e) {
    toast.error(e?.response?.data?.detail || "Error");
  }
}

/** Drop an empty secret so the backend keeps the stored one. */
export function withoutEmpty(payload, key) {
  const copy = { ...payload };
  if (!copy[key]) delete copy[key];
  return copy;
}
